// extracted by mini-css-extract-plugin
export var tile = "itemTile-module--tile--3xU1m";
export var title = "itemTile-module--title--1-7pG";
export var list = "itemTile-module--list--1ySfY";
export var icon = "itemTile-module--icon--s9Bom";